<template>
  <div class="columns is-flex-wrap">
    <div v-for="file in files" :key="file.id" class="column" :class="columnClass">
      <file-attachment :file="file"></file-attachment>
    </div>
    <div v-for="link in links" :key="link.id" class="column" :class="columnClass">
      <link-attachment :link="link"></link-attachment>
    </div>
  </div>
</template>

<script>
import FileAttachment from "@/widgets/agenda/components/sessions/FileAttachment";
import LinkAttachment from "@/widgets/agenda/components/sessions/LinkAttachment";

export default {
  name: "AttachmentList",

  components: {
    FileAttachment,
    LinkAttachment
  },

  props: ["files", "links", "columnClass"]
};
</script>

<style lang="scss" scoped>
.column {
  min-width: 0;
}
</style>
